import { objectHasKeys, isNullOrUndefined } from '@/utils/comparators'
import {
  fetchWelcomeOffer as fetchWelcomeOfferFromApi,
  fetchWorldCredits as fetchWorldCreditsFromApi,
  fetchUnlimitedProducts as fetchUnlimitedProductsApi,
  fetchDeals as fetchDealsFromApi,
  fetchProductById as fetchProductByIdFromApi
} from '@/api/sales'

const fetchWelcomeOffer = async ({ commit }) => {
  try {
    let response = await fetchWelcomeOfferFromApi()
    commit('SET_WELCOME_OFFER', response)
  } catch (ex) {
    commit('SET_WELCOME_OFFER', false)
  }
}

const loadWelcomeOffer = async ({ dispatch, state }) => {
  if (state.welcomeOffer === null && state.welcomeOffer !== false) {
    await dispatch('fetchWelcomeOffer')
  }
}

const fetchWorldCredits = async ({ commit }, currencyRequest) => {
  let response = await fetchWorldCreditsFromApi(currencyRequest)
  commit('SET_WORLD_CREDITS', response)
}

const fetchDeals = async ({ commit }) => {
  let response = await fetchDealsFromApi()
  commit('SET_DEAL_PRODUCTS', response)
}

const loadWorldCredits = async ({ dispatch, state }, currencyRequest) => {
  if (!objectHasKeys(state.worldCredits)) {
    await dispatch('fetchWorldCredits', currencyRequest)
  }
}

const fetchSubscriptions = async ({ commit }) => {
  commit('SET_FETCH_SUBSCRIPTIONS_IN_PROGRESS')
  try {
    let response = await fetchUnlimitedProductsApi()
    commit('SET_PRODUCTS', response)
  } catch (error) {
    commit('SET_ERROR_FETCH_SUBSCRIPTIONS', error)
    console.error('fetchSubscriptions', error)
  }
}

const loadProducts = async ({ dispatch, state }) => {
  if (!objectHasKeys(state.subscriptions)) {
    await dispatch('fetchSubscriptions')
  }
}

const fetchProductById = async ({commit}, id) => {
  let response = await fetchProductByIdFromApi(id)
  commit('ADD_PRODUCT', response)
}

const loadProductById = async ({dispatch, state}, id) => {
  if (!state.subscriptions || isNullOrUndefined(state.subscriptions[id])) {
    await dispatch('fetchProductById', id)
  }
}

const fetchDealById = async ({commit}, id) => {
  let response = await fetchProductByIdFromApi(id)
  commit('ADD_DEAL', response)
}

const loadDealById = async ({dispatch, state}, id) => {
  if (!state.deals || isNullOrUndefined(state.deals[id])) {
    await dispatch('fetchDealById', id)
  }
}

export default {
  fetchWelcomeOffer,
  loadWelcomeOffer,
  fetchWorldCredits,
  fetchDeals,
  loadWorldCredits,
  fetchSubscriptions,
  loadProducts,
  fetchProductById,
  loadProductById,
  fetchDealById,
  loadDealById
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/products/actions.js